// Module
var code = "<h2>Version: {{package.name}} {{package.version}}</h2> <br/> <h2>Dependencies: </h2> <ul> <li data-ng-repeat=\"(key, value) in package.dependencies\"> {{key}} - {{value}} </li> </ul> <br> <h2>Resolutions: </h2> <ul> <li data-ng-repeat=\"(key, value) in package.resolutions\"> {{key}} - {{value}} </li> </ul> ";
// Exports
module.exports = code;